"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = exports.components = void 0;
const muiBadge_1 = __importDefault(require("./muiBadge"));
const muiButton_1 = __importDefault(require("./muiButton"));
const muiButtonGroup_1 = __importDefault(require("./muiButtonGroup"));
const muiDialog_1 = __importDefault(require("./muiDialog"));
const muiDivider_1 = __importDefault(require("./muiDivider"));
const muiFormLabel_1 = __importDefault(require("./muiFormLabel"));
const muiGrid2_1 = __importDefault(require("./muiGrid2"));
const muiIconButton_1 = __importDefault(require("./muiIconButton"));
const muiInput_1 = __importDefault(require("./muiInput"));
const muiListItem_1 = __importDefault(require("./muiListItem"));
const muiMenuItem_1 = __importDefault(require("./muiMenuItem"));
const muiOutlinedInput_1 = __importDefault(require("./muiOutlinedInput"));
const muiSwitch_1 = __importDefault(require("./muiSwitch"));
const muiTab_1 = __importDefault(require("./muiTab"));
const muiTypography_1 = __importDefault(require("./muiTypography"));
exports.components = {
    MuiBadge: muiBadge_1.default,
    MuiButton: muiButton_1.default,
    MuiButtonGroup: muiButtonGroup_1.default,
    MuiDialog: muiDialog_1.default,
    MuiDivider: muiDivider_1.default,
    MuiFormLabel: muiFormLabel_1.default,
    MuiGrid2: muiGrid2_1.default,
    MuiIconButton: muiIconButton_1.default,
    MuiInput: muiInput_1.default,
    MuiListItem: muiListItem_1.default,
    MuiMenuItem: muiMenuItem_1.default,
    MuiOutlinedInput: muiOutlinedInput_1.default,
    MuiSwitch: muiSwitch_1.default,
    MuiTab: muiTab_1.default,
    MuiTypography: muiTypography_1.default,
};
exports.typography = {
    fontFamily: '"Montserrat", "Arial", "Helvetica", sans-serif',
};
//# sourceMappingURL=index.js.map